import { timeTypeTrans } from "../../_config/constant";
import { getRangeDateLength } from "../../utils/utils";

export const getDurationContrastDate = (durationDate: any) => {
  const { value, type } = durationDate || {};
  const [start, end] = value || [];
  const len = getRangeDateLength(start, end, timeTypeTrans[type]);
  const contrastStartDate = {
    date: start?.clone()?.subtract(1, 'day'),
    week: start?.clone()?.subtract(1, 'week'),
    month: start?.clone()?.subtract(1, 'month'),
  }
  const dateMap: any = {
    date: [contrastStartDate.date, contrastStartDate.date.clone()?.add(len, 'day')],
    week: [contrastStartDate.week, contrastStartDate.week.clone()?.add(len, 'week').endOf('week')],
    month: [contrastStartDate.month, contrastStartDate.month.clone()?.add(len, 'month').endOf('month')],
  }
  return {
    type: type,
    value: dateMap?.[type]
  }
}